import * as angular from "angular";
import {IController, IScope} from "angular";

export class auctionListItemCtrl implements IController {

  id: any;

  private auction: any;

  /* @ngInject */
  constructor(private $auction, private $scope: IScope) {
  }

  $onInit() {
    if (this.id) {
      this.$auction(this.id).$bindCtrlToId(this.$scope, this, 'auction', 'id');
    }
  }

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.auctions')
  .component('auctionListItem', {
    bindings: {
      id: '<'
    },
    template: require('./auction-list-item.html').default,
    controller: auctionListItemCtrl
  });

